<!--
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2026-01-06 11:46:46 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-07-15 09:04:15 +0800
 * @FilePath     : /ai-agent-lumina/src/layout/index.vue
 * @Description  : 文件描述
-->
<style lang="scss" scoped>
.layout-container {
  display: flex;
  flex-direction: column;
  background-color: var(--izt-background-color);
  height: 100vh;
  overflow: hidden;
  position: relative;
  .layout-main-content {
    flex: 1;
    min-height: 0;
  }
}
</style>

<template>
  <div class="layout-container">
    <frame-head v-if="route.meta.isHead"/>
    <div class="layout-main-content">
      <router-view v-slot="{ Component, route }">
        <keep-alive :include="visitedViewPaths">
          <component :is="Component" :key="route.path" />
        </keep-alive>
      </router-view>
    </div>
    <!-- TODO H5暂时用不到菜单栏 -->
    <!-- <tabbar /> -->
  </div>
</template>

<script setup name="layout">
  import { onMounted, computed } from 'vue'
  import { useRoute } from 'vue-router'
  import frameHead from './components/frame-head.vue'
  import tabbar from './components/tabbar.vue'
  defineOptions({ name: 'layout' })

  const route = useRoute()

  const visitedViewPaths = computed(() => {
    return ['chat', 'exhibitor']
  })
</script>